import { Button, Card, Flex, Typography } from "antd";
import {
  FileTextTwoTone,
  EditTwoTone,
  SafetyCertificateTwoTone,
} from "@ant-design/icons";
import React from "react";

export const RenewalIntro = ({ onStartRenewal }) => {
  return (
    <div style={{ height: "100%" }} className="centered-body-background">
      <Flex
        justify="center"
        align="center"
        className="expanded-height"
        vertical
      >
        <Card
          style={{
            minWidth: 300,
            maxWidth: 600,
            marginLeft: 18,
            marginRight: 18,
          }}
          bodyStyle={{ padding: 28 }}
        >
          <Typography.Title level={3} style={{ marginTop: 0 }}>
            Private Aviation Renewal
          </Typography.Title>

          <Typography.Paragraph style={{ fontSize: 15, marginBottom: 20 }}>
            We’ve pre-filled your renewal application using the information you
            submitted last year. Please review each section to confirm your
            details are still accurate, make any updates if needed, and sign at
            the end to complete your renewal.
          </Typography.Paragraph>

          <Typography.Paragraph type="secondary" style={{ marginBottom: 16 }}>
            What to expect:
          </Typography.Paragraph>

          <div style={{ display: "grid", rowGap: 14, marginBottom: 32 }}>
            <InfoRow
              icon={<FileTextTwoTone />}
              text="Review your pre-filled information step-by-step"
            />
            <InfoRow
              icon={<EditTwoTone />}
              text="Update anything that has changed"
            />
            <InfoRow
              icon={<SafetyCertificateTwoTone />}
              text="Sign electronically to finalize your renewal"
            />
          </div>

          <Flex justify="center">
            <Button type="primary" onClick={onStartRenewal} size="large">
              Start My Renewal
            </Button>
          </Flex>
        </Card>
      </Flex>
    </div>
  );
};

const InfoRow = ({ icon, text }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 12, paddingLeft: 8 }}>
    <div
      style={{
        fontSize: 20,
        width: 26,
        display: "flex",
        justifyContent: "center",
      }}
    >
      {icon}
    </div>
    <Typography.Text>{text}</Typography.Text>
  </div>
);
